import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { TableSorting, TableSortingChangedAction } from '..';

export const useTableSorting = (sorting: TableSorting, sortingChanged: TableSortingChangedAction) => {
    const dispatch = useDispatch();

    const onSortChange = useCallback(
        (sortColumn: string) => {
            let sortDirection: 'asc' | 'desc';
            if (sortColumn === sorting.column) {
                sortDirection = sorting.direction === 'asc' ? 'desc' : 'asc';
            } else {
                sortDirection = 'asc';
            }

            dispatch(
                sortingChanged({
                    sortColumn: sortColumn,
                    direction: sortDirection
                })
            );
        },
        [dispatch, sorting, sortingChanged]
    );

    const direction: 'ASC' | 'DESC' = sorting.direction === 'asc' ? 'ASC' : 'DESC';
    const column = sorting.column;

    return { direction, column, onSortChange };
};
